import { t } from 'i18next';
import { NotificationTypes } from 'server/src/shared/NotificationTypes';

import {
  NotificationIconType,
  NotificationItemData,
  NotificationQueryItem,
} from '../types';
import { routes } from '../../../routes';

const i18prefix = 'notifications.approvalRequest';

const iconsByType = new Map<string, NotificationIconType>([
  [NotificationTypes.APPROVAL_REQUEST_CREATED, 'checkbox-outline'],
]);

const titlesByType = new Map([
  [NotificationTypes.APPROVAL_REQUEST_CREATED, t(`${i18prefix}.created`)],
]);

export const mapApprovalRequestNotificationRenderInfo = (
  src: NotificationQueryItem,
): NotificationItemData | null => {
  const data: NotificationItemData = {
    comment: '',
    urlLabel: '',
    url: '',
    description: '',
  };
  data.icon = iconsByType.get(src.flair__Type__c);
  data.title = titlesByType.get(src.flair__Type__c) || '';

  if (src.renderInfo.__typename === 'ApprovalRequestNotificationRenderInfo') {
    data.url = routes.pendingApprovalRequests.route.create({});

    const approvalRequest = src.renderInfo.approvalRequest;
    if (approvalRequest) {
      const requestId = approvalRequest.Id;
      if (requestId) {
        data.url = routes.pendingApprovalRequests.route
          .withQueryParams({ approvalRequestId: requestId })
          .create({});
      }
      const employeeName = approvalRequest.recordEmployee?.Name;
      if (employeeName) {
        data.description = employeeName;
      }
      const shortDescription = approvalRequest.flair__Short_Description__c;
      if (shortDescription) {
        data.urlLabel = shortDescription;
      }
    }
  }

  return data;
};
